import React, { useState } from "react";
import { Link } from "react-router-dom";
import { UiRowContainer } from "../../../_uiComponents/grid-container/GridContainer";
import { UiCol } from "../grid-container/GridContainer";
import { propTypes } from "react-bootstrap/esm/Image";
import { isMobile } from 'react-device-detect';
import ReactPlayer from 'react-player';


export const UiLeftContentRightImageBlock = (props) => {

    const [loading, setLoading] = useState(true);

    const handleReady = () => {
        setLoading(false);
    };

    return (
        <>
            <div className="sb-left-content-right-image-wrapper">
                <UiCol lg="12" xl="6">
                    <div className="sb-left-content-right-image-wrapper__content-sec">
                        {props.children}
                    </div>

                </UiCol>

                <UiCol lg="12" xl="6">
                    <div className="sb-left-content-right-image-wrapper__img-sec">
                        {props.image1 && <img src={props.image1} />}
                        {props.image2 && <img src={props.image2} />}
                        {props.image3 && <img src={props.image3} />}
                        {props.image4 && <img src={props.image4} />}
                        {props.image5 && <img src={props.image5} />}
                        {props.image6 && <img src={props.image6} />}
                        {props.image7 && <img src={props.image7} />}
                        {props.image8 && <img src={props.image8} />}
                        {props.image9 && <img src={props.image9} />}
                        {props.image10 && <img src={props.image10} />}

                        {props.mobileVideo && props.desktopVideo &&
                            <div className="sb-campaign-video-sec">
                                {loading && (
                                    <div className="sb-video-banner-bg">
                                        <img src={props.videoBanner} />
                                    </div>
                                )}

                                <ReactPlayer url={isMobile ? props.mobileVideo : props.desktopVideo}
                                    loop={true}
                                    controls={true}
                                    config={{
                                        file: {
                                            attributes: {
                                                preload: 'none'
                                            }
                                        }
                                    }}
                                    playing={true}
                                    onReady={handleReady}
                                    playsinline={true}
                                    muted={true}
                                    style={loading ? { display: 'none' } : { display: 'block' }}
                                    width='100%'
                                    height='99%'
                                />
                            </div>
                        }
                    </div>
                </UiCol>
            </div>
        </>
    )
}

export const UiLeftContentRightThreeImageBlock = (props) => {
    return (
        <>
            <div className="sb-left-content-right-image-wrapper sb-thr-img-block">
                <UiRowContainer>
                    <UiCol lg="12" xl="7">
                        <div className={props.singleImage ? 'sb-single-image-left-content':"sb-left-content-right-image-wrapper__content-sec"}>
                            {props.children}
                        </div>

                    </UiCol>

                    <UiCol lg="12" xl="5">
                        {props.singleImage ?
                            <div className="sb-left-content-right-image-wrapper sb-content-right-single-wrapper">
                                {props.singleImage && <img src={props.singleImage} />}
                            </div>
                            :
                            <div className="sb-left-content-right-image-wrapper sb-thr-img-block__img-sec">
                                <div>
                                    {props.image1 && <img src={props.image1} />}
                                    {props.image2 && <img src={props.image2} />}
                                </div>
                            </div>
                        }

                    </UiCol>
                </UiRowContainer>
            </div>
        </>
    )
}

export const UiLeftContentTopBlock = (props) => {
    return (
        <>
            <div className="sb-left-content-right-image-wrapper sb-thr-img-block">
                <UiRowContainer>
                    <UiCol lg="12">
                        <div className={"sb-left-content-right-image-wrapper__content-sec"}>
                            {props.children}
                        </div>

                    </UiCol>      
                </UiRowContainer>
            </div>
        </>
    )
}